// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iT6FF","colBig":"styles_colBig__xk1Ly","colSmall":"styles_colSmall__39-3s"};